var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchnot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 32,
    viewBox: "0 0 52 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 50,
    height: 30,
    rx: 15,
    fill: "#EBEBEB",
    stroke: "#696969",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#696969"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6663 12.2734L19.7263 11.3334L15.9997 15.06L12.273 11.3334L11.333 12.2734L15.0597 16L11.333 19.7267L12.273 20.6667L15.9997 16.94L19.7263 20.6667L20.6663 19.7267L16.9397 16L20.6663 12.2734Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchnot);
export default __webpack_public_path__ + "static/media/Switch not.017b0f98c2088c678b6d511af8d9e4b0.svg";
export { ForwardRef as ReactComponent };